'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlay = require('./overlay.js');

var _overlay2 = _interopRequireDefault(_overlay);

var _gateway = require('./gateway.js');

var _gateway2 = _interopRequireDefault(_gateway);

var _position = require('./position.js');

var _position2 = _interopRequireDefault(_position);

var _popup = require('./popup.js');

var _popup2 = _interopRequireDefault(_popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_overlay2['default'].Gateway = _gateway2['default'];
_overlay2['default'].Position = _position2['default'];
_overlay2['default'].Popup = _popup2['default'];

exports['default'] = _overlay2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-overlay/lib/index.js
// module id = 26
// module chunks = 0